export default {
  methods: {
    transformSortQueryParams(params) {
      const copy = { ...params };
      const retorno = {};

      copy.page -= 1;
      copy.size = copy.limit;
      delete copy.limit;

      if (copy.sortBy) {
        let orderBy = 'ASC';
        if (copy.orderBy === 'desc') {
          orderBy = 'DESC';
        }
        retorno.orderBy = copy.sortBy;
        retorno.order = orderBy;
        delete copy.sortBy;
        delete copy.orderBy;
      }
      Object.assign(retorno, copy);
      return retorno;
    },
    updatedSelectedRows(rows) {
      this.$emit('update-selected-rows', rows);
    },
    selectAllUpdated(event) {
      this.$emit('updated-select-all-value', {
        selected: event,
        rows: this.rows,
      });
    },
    selectAllStatusChange(status) {
      this.$emit('select-all-status-change', status);
    },
  },
};
